module.exports = __webpack_public_path__ + "static/media/elevat.8eec5b0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/botrytis_fresa/curativa/elevat.png
// module id = 1541
// module chunks = 3